var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8867 19.1962L20.4671 15.6813H20.4592C19.8075 14.7099 19.386 13.5968 19.2377 12.4535L18.3869 5.8715C18.1078 3.6926 16.738 1.78394 14.7261 0.763466C13.7368 0.264568 12.6264 0 11.5161 0C10.4058 0 9.29543 0.264568 8.30414 0.763466C6.29227 1.78394 4.9224 3.69449 4.64336 5.8715L3.79451 12.4535C3.64036 13.6271 3.20324 14.7666 2.52806 15.7474L0.155196 19.1962C-0.0340868 19.4721 -0.0516454 19.8236 0.110319 20.1128C0.270331 20.4038 0.582548 20.5852 0.924038 20.5852H7.5548C7.78897 22.5354 9.48666 24 11.52 24C13.5533 24 15.253 22.5335 15.4852 20.5852H22.116C22.4574 20.5852 22.7697 20.4038 22.9297 20.1146C23.0917 19.8255 23.0741 19.474 22.8848 19.1981L22.8867 19.1962ZM13.6275 20.5852C13.4031 21.532 12.523 22.2142 11.5161 22.2142C10.5092 22.2142 9.62912 21.532 9.40471 20.5852H13.6275ZM20.3812 18.7994H2.6471L4.06575 16.7395C4.90093 15.5263 5.43951 14.1222 5.6288 12.6765L6.47765 6.09449C6.68255 4.49575 7.68749 3.09543 9.16273 2.35087C10.636 1.6063 12.3962 1.6063 13.8695 2.35087C15.3447 3.09921 16.3477 4.49953 16.5545 6.09449L17.4034 12.6765C17.5907 14.1222 18.1313 15.5282 18.9664 16.7395L20.3851 18.7994H20.3812Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.f3123df95d2b3476cd8c42df6618d022.svg";
export { ForwardRef as ReactComponent };